import useSWR from "swr";
import { fetcher } from "../lib/api";
import type { CellDetail } from "../types/cell";

export function useCellDetail(cellId: string | null, tickId: string | null) {
  const key =
    cellId && tickId
      ? `/cells/${encodeURIComponent(cellId)}?tick_id=${encodeURIComponent(tickId)}`
      : null;
  const { data, error, isLoading } = useSWR<CellDetail>(key, fetcher, {
    revalidateOnFocus: false,
  });
  return { cell: data, isLoading, error };
}
